import React, { Component } from 'react';
import { Formik, Field } from 'formik';
import { Link } from 'react-router-dom';
import Button from '../utility/Button';
import CustomInput from '../utility/CustomInput';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import { getAuthErr } from '../../js/utility';

import {
  doRequestPasswordReset,
  doSubmitForgotPassword,
  clearAuthError
} from '../../actions/auth';

import { setSignupFlow } from '../../actions/contest';

import { SITE_TITLE } from '../../constants';

import {
  validateEmail,
  validate6Digits,
  validatePassword,
  validateMatchPassword
} from '../../js/validators';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { clearAuthError } = this.props;
    clearAuthError();
  }

  render() {
    const {
      authError,
      canResetPassword,
      doRequestPasswordReset,
      doSubmitForgotPassword,
      passwordIsReset,
      loading,
      t,
      contest
    } = this.props;

    let message = t('form:forgotPassEnterEmail');
    if (canResetPassword) {
      message = t('form:forgotPassCodeText');
    } else if (passwordIsReset) {
      message = t('form:passResetSuccessText');
    }
    return (
      <>
        <Helmet>
          <title>
            {t('form:forgotPassword')} | {SITE_TITLE}
          </title>
        </Helmet>
        <h1 className='fe-auth-heading'>
          {passwordIsReset
            ? t('form:passResetSuccess')
            : t('form:forgotPassword')}
        </h1>
        <div className='fe-auth-text'>{message}</div>
        {!passwordIsReset ? (
          <Formik
            validateOnChange={true}
            validateOnBlur={true}
            initialValues={{
              email: '',
              code: '',
              password: '',
              retypePassword: ''
            }}
            onSubmit={values => {
              if (!canResetPassword) {
                doRequestPasswordReset(values.email);
              } else {
                doSubmitForgotPassword(
                  values.email,
                  values.code,
                  values.password
                );
              }
            }}
          >
            {({ errors, values, handleBlur, handleSubmit }) => (
              <form noValidate onSubmit={handleSubmit} className='fe-form'>
                <div className='fe-form-content'>
                  {!canResetPassword ? (
                    <div className='fe-form-field full'>
                      <label htmlFor='email'>{t('form:email')}</label>
                      <Field
                        type='text'
                        name='email'
                        component={CustomInput}
                        validate={validateEmail}
                      />
                    </div>
                  ) : (
                    <>
                      <div className='fe-form-field full'>
                        <label htmlFor='code'>
                          {t('form:verificationCode')}
                        </label>
                        <Field
                          type='text'
                          name='code'
                          component={CustomInput}
                          validate={canResetPassword && validate6Digits}
                          numbersOnly
                        />
                      </div>
                      <div className='fe-form-field full'>
                        <label htmlFor='password'>
                          {t('form:newPassword')}
                        </label>
                        <Field
                          type='password'
                          name='password'
                          isPassword
                          showError={false}
                          component={CustomInput}
                          validate={canResetPassword && validatePassword}
                        />
                      </div>
                      <div className='fe-form-field full'>
                        <div>Complete these password requirements</div>
                        <ul>
                          <li
                            className={`${
                              (errors.password !== undefined &&
                                errors.password.indexOf('fPasswordUppercase') >
                                  -1 ===
                                  false) ||
                              (values.password !== '' &&
                                errors.password === undefined)
                                ? 'ok'
                                : ''
                            }`}
                          >
                            <div
                              className={`dot ${
                                (errors.password !== undefined &&
                                  errors.password.indexOf(
                                    'fPasswordUppercase'
                                  ) >
                                    -1 ===
                                    false) ||
                                (values.password !== '' &&
                                  errors.password === undefined)
                                  ? 'ok'
                                  : ''
                              }`}
                            />
                            One uppercase character
                          </li>
                          <li
                            className={`${
                              (errors.password !== undefined &&
                                errors.password.indexOf('fPasswordLowercase') >
                                  -1 ===
                                  false) ||
                              (values.password !== '' &&
                                errors.password === undefined)
                                ? 'ok'
                                : ''
                            }`}
                          >
                            <div
                              className={`dot ${
                                (errors.password !== undefined &&
                                  errors.password.indexOf(
                                    'fPasswordLowercase'
                                  ) >
                                    -1 ===
                                    false) ||
                                (values.password !== '' &&
                                  errors.password === undefined)
                                  ? 'ok'
                                  : ''
                              }`}
                            />
                            One lower character
                          </li>
                          <li
                            className={`${
                              (errors.password !== undefined &&
                                errors.password.indexOf('fPasswordNumber') >
                                  -1 ===
                                  false) ||
                              (values.password !== '' &&
                                errors.password === undefined)
                                ? 'ok'
                                : ''
                            }`}
                          >
                            <div
                              className={`dot ${
                                (errors.password !== undefined &&
                                  errors.password.indexOf('fPasswordNumber') >
                                    -1 ===
                                    false) ||
                                (values.password !== '' &&
                                  errors.password === undefined)
                                  ? 'ok'
                                  : ''
                              }`}
                            />
                            One number
                          </li>
                          <li
                            className={`${
                              (errors.password !== undefined &&
                                errors.password.indexOf('fPasswordSymbol') >
                                  -1 ===
                                  false) ||
                              (values.password !== '' &&
                                errors.password === undefined)
                                ? 'ok'
                                : ''
                            }`}
                          >
                            <div
                              className={`dot ${
                                (errors.password !== undefined &&
                                  errors.password.indexOf('fPasswordSymbol') >
                                    -1 ===
                                    false) ||
                                (values.password !== '' &&
                                  errors.password === undefined)
                                  ? 'ok'
                                  : ''
                              }`}
                            />
                            One symbol or special character
                          </li>
                          <li
                            className={`${
                              (errors.password !== undefined &&
                                errors.password.indexOf('fPasswordNoSpace') >
                                  -1 ===
                                  false) ||
                              (values.password !== '' &&
                                errors.password === undefined)
                                ? 'ok'
                                : ''
                            }`}
                          >
                            <div
                              className={`dot ${
                                (errors.password !== undefined &&
                                  errors.password.indexOf('fPasswordNoSpace') >
                                    -1 ===
                                    false) ||
                                (values.password !== '' &&
                                  errors.password === undefined)
                                  ? 'ok'
                                  : ''
                              }`}
                            />
                            Cannot contain spaces
                          </li>
                          <li
                            className={`${
                              (errors.password !== undefined &&
                                errors.password.indexOf('fPassword8Chars') >
                                  -1 ===
                                  false) ||
                              (values.password !== '' &&
                                errors.password === undefined)
                                ? 'ok'
                                : ''
                            }`}
                          >
                            <div
                              className={`dot ${
                                (errors.password !== undefined &&
                                  errors.password.indexOf('fPassword8Chars') >
                                    -1 ===
                                    false) ||
                                (values.password !== '' &&
                                  errors.password === undefined)
                                  ? 'ok'
                                  : ''
                              }`}
                            />
                            8 characterts minimum
                          </li>
                        </ul>
                      </div>
                      <div className='fe-form-field full'>
                        <label htmlFor='retypePassword'>
                          {t('form:confirmNewPassword')}
                        </label>
                        <Field
                          type='password'
                          name='retypePassword'
                          isPassword
                          component={CustomInput}
                          validate={
                            canResetPassword &&
                            (val => validateMatchPassword(val, values.password))
                          }
                        />
                      </div>
                    </>
                  )}
                  <Button className='btn-auth' type='submit' disabled={loading}>
                    {loading ? `${t('form:submitting')}...` : t('form:submit')}
                  </Button>
                </div>
                <span className='fe-form-error'>
                  {authError ? t(`error:${getAuthErr(authError.code)}`) : ''}
                </span>
              </form>
            )}
          </Formik>
        ) : null}
        <div className='fe-auth-note'>
          {!contest ? (
            <Link to='/login'>
              {passwordIsReset
                ? t('form:proceedToLogin')
                : t('form:backToLogin')}
            </Link>
          ) : (
            <div onClick={() => this.props.setSignupFlow('login')}>
              {passwordIsReset
                ? t('form:proceedToLogin')
                : t('form:backToLogin')}
            </div>
          )}
        </div>
      </>
    );
  }
}

ForgotPassword.propTypes = {
  authError: PropTypes.object,
  canResetPassword: PropTypes.bool.isRequired,
  doRequestPasswordReset: PropTypes.func.isRequired,
  doSubmitForgotPassword: PropTypes.func.isRequired,
  passwordIsReset: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  clearAuthError: PropTypes.func.isRequired,
  setSignupFlow: PropTypes.func.isRequired
};

const mapStateToProps = ({ authState }) => ({
  authError: authState.authError,
  loading: authState.loading,
  canResetPassword: authState.canResetPassword,
  passwordIsReset: authState.passwordIsReset
});

const mapDispatchToProps = {
  doRequestPasswordReset,
  doSubmitForgotPassword,
  clearAuthError,
  setSignupFlow
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ForgotPassword)
);
